<template>
  <div class="community-forum-list">
    <div v-if="loading" class="text-center py-4">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <div v-if="!forums.length" class="empty text-center py-5">
        Nenhum fórum disponível nesta comunidade ainda.
      </div>

      <router-link
        v-for="forum in forums"
        :key="forum.id"
        class="forum-card d-flex align-items-center"
        :to="{
          name: 'community-forum',
          params: { id: communityId, forumId: forum.id }
        }"
      >
        <div class="forum-icon mr-3">
          <i class="icon-talk" />
        </div>
        <div class="flex-fill">
          <h5 class="forum-name mb-1">{{ forum.name }}</h5>
          <p v-if="forum.description" class="forum-description mb-0">
            {{ forum.description }}
          </p>
        </div>
        <i class="icon-chevron-right forum-chevron" />
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: "ForumList",
  props: {
    communityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      forums: [],
      loading: true
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      return this.$store
        .dispatch("community/listForums", this.communityId)
        .then(data => {
          this.forums = data && data.results ? data.results : data || [];
        })
        .catch(() => this.$message.error("Não foi possível carregar os fóruns"))
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-forum-list {
  .empty {
    opacity: 0.7;
  }

  .forum-card {
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(128, 128, 128, 0.2);
    color: inherit;
    text-decoration: none;
    margin-bottom: 12px;
    transition: border-color 0.15s ease;

    &:hover {
      border-color: rgba(128, 128, 128, 0.45);
    }

    .forum-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(128, 128, 128, 0.16);
      flex-shrink: 0;

      i {
        font-size: 20px;
      }
    }

    .forum-name {
      font-size: 16px;
      font-weight: 600;
    }

    .forum-description {
      font-size: 13px;
      opacity: 0.7;
      overflow-wrap: anywhere;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .forum-chevron {
      font-size: 20px;
      opacity: 0.5;
      flex-shrink: 0;
    }
  }
}
</style>
